import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);


const slider1 = document.querySelector('.hero-slider');

let mySwiper1 = new Swiper(slider1, {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    1025: {
      // slidesPerView: 3,
    },
    768: {
      // slidesPerView: 2,
    }
  }
})

const slider2 = document.querySelector('.sample-slider');

let mySwiper2 = new Swiper(slider2, {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.swiper-button-next--sample',
    prevEl: '.swiper-button-prev--sample',
  },
  breakpoints: {
    1300: {
      slidesPerView: 2,
    },
  }
})

const slider3 = document.querySelector('.partners-slider');

let mySwiper3 = new Swiper(slider3, {
  slidesPerView: 1.7,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.swiper-button-next--partners',
    prevEl: '.swiper-button-prev--partners',
  },
  breakpoints: {
    1150: {
      slidesPerView: 4,
    },
    800: {
      slidesPerView: 3,
    },
  }
})
const slider4 = document.querySelector('.similar-slider');

let mySwiper4 = new Swiper(slider4, {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.swiper-button-next--similar-slider',
    prevEl: '.swiper-button-prev--similar-slider',
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
  }
})
const slider5 = document.querySelector('.similar-slider2');

let mySwiper5 = new Swiper(slider5, {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.swiper-button-next--similar-slider2',
    prevEl: '.swiper-button-prev--similar-slider2',
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
  }
})

const slider = document.querySelector('.slider-main');
const sliderNav = document.querySelector('.slider-nav');

let mySwiperNav = new Swiper(sliderNav, {
  slidesPerView: 3,
  spaceBetween: 30,
  loopedSlides: 3,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

let mySwiper = new Swiper(slider, {
  spaceBetween: 30,
  loop: true,
  loopedSlides: 3,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: mySwiperNav,
  }
})